module.exports = __webpack_public_path__ + "img/color-3.93bda24.png";